<template lang="html">
  <div id="userList">
    <table id="userListTable">
      <caption>ユーザー一覧</caption>
      <caption>
        <div class="cp_iptxt">
        	<input class="ef" type="text"  v-model="searchText">
        	<label>氏名</label>
        	<span class="focus_line"></span>
        </div>
      </caption>
      <caption>
        <el-checkbox v-model="isShowAdmin" label="管理者を表示する" ></el-checkbox>
        <el-checkbox v-model="isShowStudent" label="生徒を表示する" ></el-checkbox>
        <el-checkbox v-model="isShowTeacher" label="教師を表示する" ></el-checkbox>
      </caption>
      <thead>
          <tr>
            <th>ID</th>
            <th>ユーザー名</th>
            <th>氏名</th>
            <th>フリガナ</th>
            <th>種類</th>
            <th>ステータス</th>
            <th>削除</th>
          </tr>
      </thead>
      <tbody>
        <tr class="userlist" v-for="(user, index) in userlistFiltered" :key="user.id"
        :class="{ itemEven: index % 2 === 0 }" v-if="user.school_id == $store.state.userInfo.school_id || user.user_type == 'teacher'">
        <td>{{user.user_id}}</td>
        <td>{{user.user_name}}</td>
        <td>
          <router-link :to="{ path: '/management/user/' + user.user_id }"
          class="colFullname"
          >{{user.fullname}}</router-link>
        </td><!--@click.native="loadUserLectures(user.user_id)" <router-link>内にあったがよくわからないのでとりあえずコメントアウト -->
        <td>{{user.kana}}</td>
        <td>{{userTypeDisplay(user.user_type)}}</td>
        <td>{{userStatusDisplay(user.user_status)}}</td>
        <td>
          <button class="colDeleteButton" @click="deleteUserHandler(user.user_id)">削除</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'
export default {
  name: 'user-list',
  data () {
    return {
      isShowAdmin: true,
      isShowStudent: true,
      isShowTeacher: true,
      searchText: ''
    }
  },
  methods: {
    ...mapActions([
      'updateUserList',
      'deleteUser'
    ]),
    deleteUserHandler (id) {
      let yesno = confirm('ユーザーを削除します． よろしいでしょうか？')
      if (yesno) {
        this.deleteUser(id)
        .then((res) => {
          alert('ユーザーの削除に成功しました．')
          this.updateUserList()
        })
      }
    },
    userTypeDisplay (type) {
      if (type === 'student') {
        return '生徒'
      } else if (type === 'teacher') {
        return '教師'
      } else if (type === 'admin') {
        return '管理者'
      } else if (type === 'viewer') {
        return '閲覧者'
      } else {
        return 'Unknown'
      }
    },
    userStatusDisplay (status) {
      if (status === 'trial') {
        return '体験'
      } else if (status === 'temporal') {
        return '短期'
      } else if (status === 'normal') {
        return '通常'
      } else if (status === 'temp/temp') {
        return '短期'
      } else if (status === 'temp/norm') {
        return '通常/短期'
      } else {
        return 'Unknown'
      }
    },
    kanaToHira (str) {
      return str.replace(/[\u3041-\u3096]/g, function (matchs) {
        var chr = matchs.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    }
  },
  computed: {
    userlistFiltered () {
      if (this.searchText) {
        return this.$store.state.userlist.filter((user, index, array) => {
          return (user.fullname.match(this.searchText) || user.kana.match(this.searchText) || user.kana.match(this.kanaToHira(this.searchText)))
        })
      }
      if (this.isShowAdmin) {
        if (this.isShowStudent) {
          if (this.isShowTeacher) {
            return this.$store.state.userlist
          } else {
            return this.$store.state.userlist.filter((user, index, array) => {
              return user.user_type !== 'teacher'
            })
          }
        } else {
          if (this.isShowTeacher) {
            return this.$store.state.userlist.filter((user, index, array) => {
              return user.user_type !== 'student'
            })
          } else {
            return this.$store.state.userlist.filter((user, index, array) => {
              return user.user_type === 'admin'
            })
          }
        }
      } else {
        if (this.isShowStudent) {
          if (this.isShowTeacher) {
            return this.$store.state.userlist.filter((user, index, array) => {
              return user.user_type !== 'admin'
            })
          } else {
            return this.$store.state.userlist.filter((user, index, array) => {
              return user.user_type === 'student'
            })
          }
        } else {
          if (this.isShowTeacher) {
            return this.$store.state.userlist.filter((user, index, array) => {
              return user.user_type === 'teacher'
            })
          } else {
            return this.$store.state.userlist.filter((user, index, array) => {
              return
            })
          }
        }
      }
    }
  },
  mounted () {
    this.updateUserList()
  }
}
</script>

<style lang="css" scoped>
#userList {
  overflow-y: scroll;
}
#userListTable {
  width: 100%;
  margin: auto;
}
.itemEven {
  background-color: #ffffcc
}
thead>tr>th {
  text-align: center;
}
tbody>tr:hover {
  background-color: #ffcccc
}
.cp_iptxt {
	position: relative;
	width: 20%;
	margin: 10px 3%;
}
.cp_iptxt input[type='text'] {
	font: 15px/24px sans-serif;
	box-sizing: border-box;
	width: 100%;
	letter-spacing: 1px;
	padding-left: 4em;
}
.cp_iptxt input[type='text']:focus {
	outline: none;
}
.ef {
	padding: 4px 0;
	border: 0;
	border-bottom: 1px solid #1b2538;
	background-color: transparent;
}
.ef ~ .focus_line {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 0;
	height: 2px;
	transition: 0.4s;
	background-color: #da3c41;
}
.ef:focus ~ .focus_line,
.cp_iptxt.ef ~ .focus_line {
	width: 100%;
	transition: 0.4s;
}
.ef ~ label {
	position: absolute;
	z-index: -1;
	top: 4px;
	left: 0;
	width: 100%;
	transition: 0.3s;
	letter-spacing: 0.5px;
	color: #aaaaaa;
}
.ef:focus ~ label, .cp_iptxt.ef ~ label {
	font-size: 12px;
	top: -16px;
	transition: 0.3s;
	color: #da3c41;
}
</style>



// WEBPACK FOOTER //
// UserList.vue?543306d8